"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(number) {
  return number === null || number === void 0 ? void 0 : number.toString().startsWith('62');
}